import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { CenterTile } from "./CenterTile";
import { ImageTile } from "./ImageTile";
import { ArtistSelectionSlider } from "./ArtistSelectionSlider";
import LinesGraphic from "../assets/lines.svg";
import ListIcon from "../assets/list_icon.svg";

let profileInfo = require("../artistProfileInfo.js");
let artistsData = profileInfo.getArtistProfileData();
let artists = Object.keys(artistsData);
let artistNames = artists.map((artist) => [
    artistsData[artist].sliderSortOrder,
    artist,
    artistsData[artist].name,
]);
const exitAnimationDelay = 0.2;
const exitAnimationDuration = 0.7;
const exitDelay = exitAnimationDelay * 8000 + exitAnimationDuration * 1000 + 400;

function renderImageTiles(exitPage, setExitPage, setSliderOpen) {
    return artists.map((artist, index) => (
        <ImageTile
            artist={artist}
            artistInfo={artistsData[artist]}
            index={index}
            exitPage={exitPage}
            setExitPage={setExitPage}
            setSliderOpen={setSliderOpen}
            exitAnimationDelay={exitAnimationDelay}
            exitAnimationDuration={exitAnimationDuration}
            exitDelay={exitDelay}
            mobile={false}
            key={index}
        />
    ));
}

function ArtistsFull() {
    let [sliderOpen, setSliderOpen] = useState(false);
    let [exitPage, setExitPage] = useState(false);
    let navigate = useNavigate();

    const galleryDevice =  useMediaQuery('(min-width:3000px)');
    useEffect(() => {
        if (galleryDevice) {
            let timeoutID = setTimeout(() => {
                navigate("/");
            }, 180000);
            return () => clearTimeout(timeoutID);
        }

    }, [navigate, sliderOpen, galleryDevice]);

    return (
        <Box 
            role= "navigation"
            aria-label= "Artist images. Click an image for the artist profile."
            sx={{
                height: "100vh",
                minHeight: "562.5px",
                minWidth: "1000px",
                position: "relative", //A positioned parent element as a reference for the absolutely positioned children
                backgroundColor: "secondary.main",
                aspectRatio: "16/9",
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}
        >
            <Box
                sx={{
                    paddingTop: "4.63vh",
                    paddingLeft: "3%",
                    paddingRight: "3%",
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "repeat(9, 9.1%)",
                    gripTemplateRows: "repeat(2 1fr)",
                    columnGap: "2.21%",
                    rowGap: "max(30px, 3vh)",
                }}
            >
                {renderImageTiles(exitPage, setExitPage, setSliderOpen)}
                <Box
                    sx={{
                        width: "120%",
                        position: "relative",
                        left: "-10%",
                        minWidth: "1000px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gridColumn: "1 / span 9",
                        gridRow: "2",
                        animation: exitPage ? `${exitDelay*0.5/1000}s ease fade-out forwards` : ""
                        
                    }}
                
                >
                    <img 
                        src={LinesGraphic}
                        alt="Lines graphic decoration in page center"
                        style = {{
                            animation: "expand 1.5s linear both"
                        }}
                    />
                </Box>
            </Box>


            <CenterTile
                exitPage={exitPage}
                exitDelay={exitDelay * 0.5}
                text1="Touch the screen to begin"
                text2="Tap on a photo to learn more about the artist"
                animateText={true}
            />

            <Box
                sx={{
                    height: "7.57%",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    animation: exitPage
                        ? ""
                        : "fade-in 4s ease",
                    display: {
                        xl: "flex",
                        start: "none"     
                    }
                }}
            >
                <Button
                    onClick={() => {
                        setSliderOpen(!sliderOpen);
                    }}
                    sx={{
                        height: "4.626vh",
                        minHeight: "24.44px",
                        borderRadius: "2.3148vh",
                        backgroundColor: "primary.main",
                        aspectRatio:"543/100",
                        animation: exitPage ? `${exitDelay*0.5/1000}s ease fade-out forwards` : ""
                    }}
                >
                    <img 
                        src={ListIcon}
                        alt="List icon"
                        style={{
                            height: "1.6097vh"
                        }}
                    />
                    <Typography
                        sx={{
                            color: "text.primary",
                            fontSize: "max(7px, 1.389vh)",
                            lineHeight: "max(9px,1.620vh)",
                            letterSpacing: "0.1389vh",
                            fontFamily: "GT Eesti Display Bold",
                            marginLeft: "max(7.3px, .78125vw)",
                        }}
                    >
                        Find By Name
                    </Typography>
                </Button>
            </Box>
            <ArtistSelectionSlider
                sliderOpen={sliderOpen}
                setSliderOpen={setSliderOpen}
                artistNames={artistNames}
                setExitPage={setExitPage}
                exitDelay={exitDelay}
            />
        </Box>
    );
}

export default ArtistsFull;
